import { useRef } from 'preact/hooks'
import { text } from '#contract'
import { useT } from '../i18n/index.ts'
import styles from './app-frame.module.css'

/** How far a swipe up from the indicator goes before it counts, in CSS pixels. */
const SWIPE_PX = 40

/** The phone's home indicator: a click, or a swipe up on touch, goes home. */
export function HomeIndicator({ onHome }: { readonly onHome: () => void }) {
  const t = useT()
  const startYRef = useRef<number | null>(null)
  return (
    <button
      type="button"
      class={styles.home}
      aria-label={t(text('os.home'))}
      onClick={onHome}
      onPointerDown={(event) => {
        startYRef.current = event.clientY
        event.currentTarget.setPointerCapture(event.pointerId)
      }}
      onPointerMove={(event) => {
        if (startYRef.current === null || startYRef.current - event.clientY < SWIPE_PX) return
        startYRef.current = null
        onHome()
      }}
      onPointerUp={() => {
        startYRef.current = null
      }}
      onPointerCancel={() => {
        startYRef.current = null
      }}
    >
      <span class={styles.bar} />
    </button>
  )
}
